import DataTable from '../components/DataTable';
import { KTSVG } from '../../_metronic/helpers'
import 'react-loading-skeleton/dist/skeleton.css';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { deleteRequestOptions } from '../helpers/Fetchwrapper';
import GetPagePermission from "../components/GetPagePermission";

function WarehouseTransfers() {

    const hasPermission = GetPagePermission("/warehouse-transfers");
    const transferCreatePermission = GetPagePermission("/warehouse-transfer-create");
    const transferDeletePermission = GetPagePermission("/warehouse-transfer-delete");

    const handleDelete = async (id: number) => {
        const confirm = await Swal.fire({
            title: 'Are you sure?',
            text: "You want to delete this warehouse transfer?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Yes, Delete it!',
        });

        if (confirm.isConfirmed) {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}warehouse-transfer/${id}`,
                    deleteRequestOptions()
                );
                const data = await response.json();
                
                if (data.success) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Deleted!',
                        text: data.successMessage || 'Warehouse transfer deleted successfully.',
                    });
                    // Refresh the DataTable
                    window.location.reload();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: data.error || 'Failed to delete warehouse transfer.',
                    });
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'An error occurred while deleting the warehouse transfer.',
                });
            }
        }
    };

    const columns = [
        { value: 'id', title: 'ID', style: { textAlign: 'center' } },
        { value: 'projectName', title: 'Project', style: { textAlign: 'left' } },
        { value: 'warehouseName', title: 'Warehouse From', style: { textAlign: 'left' } },
        { value: 'toWarehouseName', title: 'Warehouse To', style: { textAlign: 'left' } },
        { value: 'transferDate', title: 'Transfer Date', style: { textAlign: 'left' } },
        { value: 'createdBy', title: 'Created By', style: { textAlign: 'left' } },
        {
            value: 'action', title: 'Action', style: { textAlign: 'left', whiteSpace: 'nowrap' }, hasActionsComponent: true, actionsComponent: ((row: any) => {
                return (
                    <>
                        <Link className="btn btn-light-primary btn-sm px-2 py-1 me-2" to={`/warehouse-transfer-details/${row.id}`}>
                            <KTSVG
                                path='/media/svg/icons/Layout/Layout-grid.svg'
                                className='svg-icon-5 svg-icon'
                            />		Details
                        </Link>
                        {transferDeletePermission === 1 && (
                            <button 
                                className="btn btn-light-danger btn-sm px-2 py-1" 
                                onClick={() => handleDelete(row.id)}
                            >
                                <KTSVG
                                    path='/media/svg/icons/General/Trash.svg'
                                    className='svg-icon-5 svg-icon'
                                />		Delete
                            </button>
                        )}
                       
                    </>
                )
            })
        }
    ]

    const filters = {
        id: {
            filterType: 'like',
            filterValue: '',
        },
        projectName: {
            filterType: 'like',
            filterValue: '',
        },
        warehouseName: {
            filterType: 'like',
            filterValue: '',
        },
        toWarehouseName: {
            filterType: 'like',
            filterValue: '',
        },
        transferDate: {
            filterType: 'like',
            filterValue: '',
        },
        createdBy: {
            filterType: 'like',
            filterValue: '',
        },
    }

    const url = process.env.REACT_APP_API_URL + 'warehouse-transfer/dt'

    return (
        <>
            {hasPermission === 1 &&
                <>
                    <div className='card card-custom'>
                        <div className='card-header'>
                            <div className="card-title">
                                <KTSVG path='/media/svg/icons/Text/Bullet-list.svg' className='svg-icon-1 svg-icon-primary' />
                                <span className='text fw-bolder' style={{ marginLeft: '10px' }}>
                                    Stock Transfer List
                                </span>
                            </div>
                            {transferCreatePermission === 1 && (
                                <div className="card-toolbar">
                                    <div className='d-flex justify-content-end'>
                                        <Link to={`/warehouse-transfer-create`} className="btn btn-sm btn-primary"><i className="fa fa-plus"></i>Create New Stock Transfer</Link>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className='card-body'>
                            <DataTable url={url} columns={columns} filters={filters} />
                        </div>
                    </div >
                </>
            }

        </>
    )
}

export default WarehouseTransfers
